/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
import Loading from 'quasar/src/plugins/Loading.js';;
import http from '../../http/http';
import { success, error } from '../../../../../services/alert-message';

const urlApi = 'central/api/v1/servicos';

/**
* Buscando todos atos
* @param {*} param0
*/
export async function servicoList({ commit }, obj) {
  Loading.show();
  return (await http.get(`${urlApi}?${obj.filtro}`)
    .then(res => {
      Loading.hide();
      return res;
    })
    .catch(err => {
      Loading.hide();
      return err;
    })
  ).data;
}


export async function servicoLivros({ commit }, obj) {
  Loading.show();
  return (await http.get(`${urlApi}/${obj.servicoId}/livros`)
    .then(res => {
      Loading.hide();
      return res;
    })
    .catch(err => {
      Loading.hide();
      return err;
    })
  ).data;
}
